module.exports = __webpack_public_path__ + "img/Mashed Potatoes.e9489582.jpg";